export default "<h1 class=\"text-center\">404 | Oops, ressource is not available</h1>\r\n\r\n"